import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import Images from "assets/images"
import { EDIT, PROVEN_NO, PROVEN_IN_USE, PRIOR_USE } from "const"
import { hasAccess } from "client/utils"
import { qidProductsRoute } from "client/parts/routes"
import {
    PRM_QID_PRODUCT,
    StoreType,
    addModal,
} from "client/store"
import {
    PageForm,
    Logo,
    FormGroup,
    Label,
    Input,
    CheckboxWrapper,
    CheckButton,
    RadioButton,
    Button,
} from "client/components"

const Form = () => {
    const product = useSelector((state: StoreType) => state.qidProduct.productView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editUrl = `${qidProductsRoute}/${EDIT}/${product.id}`
    const editAccess = hasAccess(PRM_QID_PRODUCT, EDIT)

    return (
        <PageForm>
            <Row>
                <Col xs={12} md={3}>
                    <Logo logo={product.logo || Images.qidProductLogo} />
                </Col>
                <Col xs={12} md={9}>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.name}</Label>
                                <Input type="text" value={product.name} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.company}</Label>
                                <Input type="text" value={product.company ? product.company.name : ""} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.type}</Label>
                                <Input type="text" value={product.type} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.mode}</Label>
                                <CheckboxWrapper>
                                    <CheckButton
                                        checked={product.lowDemandMode}
                                        title={lang.modeLowDemand}
                                        readOnly
                                    />
                                    <CheckButton
                                        checked={product.highDemandMode}
                                        title={lang.modeHighDemand}
                                        readOnly
                                    />
                                    <CheckButton
                                        checked={product.continuousMode}
                                        title={lang.modeContinuous}
                                        readOnly
                                    />
                                </CheckboxWrapper>
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.logicSolver}</Label>
                                <Input type="text" value={product.logicSolver ? lang.yes : lang.no} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.provenReliabilityData}</Label>
                                <FormGroup inline>
                                    <RadioButton
                                        checked={product.provenInUse === PROVEN_NO}
                                        title={lang.no}
                                        readOnly
                                    />
                                    <RadioButton
                                        checked={product.provenInUse === PROVEN_IN_USE}
                                        title={lang.provenInUse}
                                        readOnly
                                    />
                                    <RadioButton
                                        checked={product.provenInUse === PRIOR_USE}
                                        title={lang.priorUse}
                                        readOnly
                                    />
                                </FormGroup>
                            </FormGroup>
                            {
                                editAccess && (
                                    <FormGroup>
                                        <Label>{lang.status}</Label>
                                        <Input type="text" value={lang[product.status]} readOnly />
                                    </FormGroup>
                                )
                            }
                        </Col>
                        {
                            editAccess
                            && (
                                <Col xs={12}>
                                    <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                        {lang.edit}
                                    </Button>
                                </Col>
                            )
                        }
                    </Row>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
